import React, { ComponentType, createContext } from 'react';
import { ClientProtectedFragment } from 'api';
import { ClientPublicFragment } from 'api/public';

export interface IWithProtectedClient {
  client: ClientProtectedFragment;
}

export interface IWithPublicClient {
  client: ClientPublicFragment;
}

export const ProtectedClientContext = createContext<IWithProtectedClient>({
  client: null,
});

export const PublicClientContext = createContext<IWithPublicClient>({
  client: null,
});

export const withProtectedClient =
  <T extends IWithProtectedClient>(Component: ComponentType<T & IWithProtectedClient>) =>
  (props: T) =>
    (
      <ProtectedClientContext.Consumer>
        {(providerProps: IWithProtectedClient) => <Component {...props} {...providerProps} />}
      </ProtectedClientContext.Consumer>
    );

export const withPublicClient =
  <T extends IWithPublicClient>(Component: ComponentType<T & IWithPublicClient>) =>
  (props: T) =>
    (
      <PublicClientContext.Consumer>
        {(providerProps: IWithPublicClient) => <Component {...props} {...providerProps} />}
      </PublicClientContext.Consumer>
    );
